import type { ReactElement } from 'react';
import type { StatusMessage } from './use-status-message';
import styles from './shared.module.css';

/**
 * Região de avisos educados (`role="status"`). Ela é renderizada SEMPRE, vazia: leitores de tela só
 * anunciam mudanças em regiões que já existiam quando o texto entrou. O texto vai num <span> com
 * `key` novo a cada aviso, para a repetição da mesma frase ser anunciada de novo.
 */
export function StatusRegion({ message }: { message: StatusMessage }): ReactElement {
  return (
    <div role="status" className={styles.status}>
      {message.text && <span key={message.id}>{message.text}</span>}
    </div>
  );
}
